import { render, staticRenderFns } from "./UpdateAPIKeysForm.vue?vue&type=template&id=492f990e&scoped=true&"
import script from "./UpdateAPIKeysForm.vue?vue&type=script&lang=js&"
export * from "./UpdateAPIKeysForm.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAPIKeysForm.vue?vue&type=style&index=0&id=492f990e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492f990e",
  null
  
)

export default component.exports